import type { UserRegion } from "@/services/users";
import type { SourcePathAskItem, SourcePathAskUserScope } from "@/services/sourcePathAsk";

export interface PathItem {
  id: string;
  site: string;
  drive: string;
  includedPaths: string[];
  excludedPaths: string[];
  /** 绑定的分类 ID（非名称）——分类改名后绑定自动跟随 */
  docCategoryIds: string[];
  /** 绑定的标签 ID 及预设值 */
  docTagBindings: Array<{ tagId: string; presetValues: string[] }>;
  /** General Source Type 对应的分类 ID */
  sourceTypeId: string;
  region: UserRegion;
  visibleToUsers: boolean;
  remark: string;
  agentTips: string;
  userScope: SourcePathAskUserScope;
}

export function normalizePath(item: SourcePathAskItem): PathItem {
  return {
    id: item.ID,
    site: item.SourceSite,
    drive: item.SourceDrive ?? "",
    includedPaths: item.IncludedPaths ?? [],
    excludedPaths: item.ExcludedPaths ?? [],
    docCategoryIds: item.DocCategoryIds ?? [],
    docTagBindings: (item.DocTagBindings ?? []).map((binding) => ({
      tagId: binding.TagId,
      presetValues: binding.PresetValues ?? [],
    })),
    sourceTypeId: item.SourceType ?? "",
    region: item.Region ?? "Mainland",
    visibleToUsers: item.VisibleToUsers ?? true,
    remark: item.Remark ?? "",
    agentTips: item.AgentTips ?? "",
    userScope: Number(item.UserScope) === 1 ? 1 : 0,
  };
}

export function formatSharePointSitePreview(site: string) {
  let value = site.trim().replace(/\\/g, "/");
  if (!value) return "";

  try {
    value = new URL(value).pathname;
  } catch {
    // 这里允许输入普通 site path。
  }

  const segments = value
    .replace(/^\/+|\/+$/g, "")
    .split("/")
    .filter(Boolean);
  if (segments[0]?.toLowerCase() === "sites") segments.shift();
  if (segments.length === 0) return "";

  const path = segments.map((segment) => encodeURIComponent(decodePathSegment(segment))).join("/");
  const prefix = segments[0]?.toLowerCase() === "teams" ? "" : "sites/";
  return `https://astrazeneca.sharepoint.com/${prefix}${path}/`;
}

function decodePathSegment(segment: string) {
  try {
    return decodeURIComponent(segment);
  } catch {
    return segment;
  }
}
